import { css } from "@emotion/css";
import { info } from "src/ui/colors";
import { SubmissionState } from "src/ui/SubmissionState";
import { buttonCss } from "./buttonCss";

export function DemoCheckScoreButton({
  submissionState, setShowSolutions,
}: {
  submissionState: SubmissionState;
  setShowSolutions: (value: boolean) => void;
}) {
  return (
    <button
      type="button"
      disabled={submissionState.status !== "pristine" && submissionState.status !== "blank"}
      className={css`
        background-color: ${info};
        ${buttonCss}
      `}
      onClick={() => {
        setShowSolutions(true);
      }}
    >
      Termina e controlla
    </button>
  );
}
